import { Box } from 'braid-design-system';
import { useEffect, useRef, useState } from 'react';

export interface HalfwayTriggerProps {
  enabled: boolean;
  action: () => void;
}

export const HalfwayTriggerOnce = ({
  enabled,
  action,
}: HalfwayTriggerProps) => {
  const triggerRef = useRef(null);
  const [hasIntersected, setHasIntersected] = useState(false);

  useEffect(() => {
    const element = triggerRef.current;

    if (!element || hasIntersected) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (enabled && entry.isIntersecting) {
        action();
        setHasIntersected(true);
      }
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [action, enabled, hasIntersected]);

  return (
    <Box
      ref={triggerRef}
      style={{
        height: 1,
        top: '50%',
        position: 'absolute',
        visibility: 'hidden',
      }}
    />
  );
};
